import request from "@/utils/request";

// 查询分类列表
export function getCategoriesList(params) {
  return request({
    url: "/admin/categories/list",
    method: "get",
    params: params
  });
}

//新增分类
export function addCategories(data) {
  return request({
    url: "/admin/categories",
    method: "post",
    data: data
  });
}

//修改分类
export function updateCategories(data) {
  return request({
    url: "/admin/categories",
    method: "put",
    data: data
  });
}

//删除分类
export function removeCategories(data) {
  return request({
    url: "/admin/categories",
    method: "delete",
    data: data
  });
}
